<template>
  <div>
    <CrudList
        title="Opciones de Ayuda"
        storeName="Help_options"
        labelAddNew="Agregar"
        :canAdd="true"
        :canEdit="true"
        :canDelete="true"
        sortable
        next-link="/admin/helps"
        :breadcrumbs="[
          {
            text: 'Información y soporte',
            disabled: false,
            href: '/admin/spot_helps'
          },
          {
            text: 'Opciones de ayuda',
            disabled: false,
            href: '#'
          }
        ]"
    >
      <!-- Columna: Descripción -->
      <template v-slot:description="{ item }">
        <div class="table-cell-fixed description-cell">
          {{ item.description }}
        </div>
      </template>

      <!-- Columna: Título -->
      <template v-slot:title="{ item }">
        <div class="table-cell-fixed">
          {{ item.title }}
        </div>
      </template>

      <!-- Columna: Requiere Foto -->
      <template v-slot:requires_photo="{ item }">
        <div class="table-cell-fixed">
          {{ item.requires_photo ? 'Sí' : 'No' }}
        </div>
      </template>

      <!-- Columna: Requiere Descripción -->
      <template v-slot:requires_description="{ item }">
        <div class="table-cell-fixed">
          {{ item.requires_description ? 'Sí' : 'No' }}
        </div>
      </template>
    </CrudList>
  </div>
</template>
<style>
.table-cell-fixed {
  min-height: 220px; /* altura mínima */
  max-height: 220px; /* altura fija */
  display: flex;
  align-items: center;
  overflow: hidden; /* evita desbordes */
}

.description-cell {
  font-size: 12px;       /* más pequeña */
  line-height: 1.2;      /* compacto */
  overflow-y: auto;      /* scroll si es muy larga */
  max-height: 100%;      /* respeta altura fija */
}
</style>


<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
